import { Button } from '@components/Button.tsx';
import { ButtonType } from '@common/types/button';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Paths } from '@src/config/paths';
import { isDirectusError, isDirectusErrorArray } from '@src/types/errors.ts';
import { useTranslation } from 'react-i18next';

export function ErrorView() {
  const error = useRouteError();
  const { t } = useTranslation('view', { keyPrefix: 'error' });

  return (
    <div
      className="w-full h-full flex flex-col justify-center items-center bg-white space-y-2 p-4"
      data-testid="GlobalErrorHandlerComponent"
    >
      <h1 className="font-semibold text-xl mb-8">{t('apology')}</h1>
      <p className="pt-6 whitespace-pre-wrap text-sm">
        {t('details', getErrorDetails(error))}
      </p>
      <Link to={'/'}>
        <Button
          label={t('buttons.backToDashboard')}
          buttonType={ButtonType.PRIMARY}
        />
      </Link>
      <Link to={Paths.LOGOUT}>
        <Button label={t('buttons.logout')} buttonType={ButtonType.SECONDARY} />
      </Link>
    </div>
  );
}

const getErrorDetails = (
  error: unknown,
): { errorMessage: string; stack: string } => {
  let errorMessage: string;
  const stack: string | undefined = (error as Error | undefined)?.stack;
  if (isRouteErrorResponse(error)) {
    errorMessage = `isRouteErrorResponse: ${error.status} ${
      error.statusText
    }\n${JSON.stringify(error.data)}`;
  } else if (isDirectusErrorArray(error)) {
    errorMessage = `Directus Errors: ${error.errors
      .map((e) => e.message)
      .join(', ')}`;
  } else if (isDirectusError(error)) {
    errorMessage = `Directus Error: ${error.message}`;
  } else if (error instanceof TypeError) {
    errorMessage = error.message;
  } else {
    errorMessage = `unknown error ${JSON.stringify(error ?? 'undefined')}`;
  }
  return { errorMessage, stack: stack ?? '' };
};
